<template>
  <div>
    <EcoBlockAnchor v-if="showEcoBlock" class="mb-8" />
    <div
      class="mb-24 grow flex-row items-center justify-between md:mb-20 md:flex"
    >
      <h1 class="heading-1">
        {{ product.rawTitle }}
      </h1>
      <Price
        v-if="product && currentGrade"
        class="ml-24 hidden md:flex"
        :offer="currentGrade"
        :product="product"
      />
    </div>

    <div class="md:grid md:grid-cols-2 md:gap-12">
      <div class="grow flex-col justify-center md:flex">
        <RatingInfo
          v-if="rating"
          anchor-id="reviews"
          class="mb-8 md:ml-0 md:w-full"
          :rating="rating"
        />
        <AdvertisedPayment
          class="hidden md:block"
          :current-grade="currentGrade"
        />
      </div>

      <div class="hidden justify-end md:flex">
        <div class="flex w-full max-w-[25.6rem] justify-between self-center">
          <RevButton
            data-id="product-page-buy-button-desktop"
            data-qa="product-page-buy-button-desktop"
            full-width="always"
            variant="primary"
            @click="onAddToCart"
          >
            {{ i18n(translations.addToCart) }}
          </RevButton>
        </div>

        <FavoritesToggle
          class="ml-12 h-48 self-center"
          :grade-id="currentGrade?.backboxGrade.value"
          :offer-type="offerType"
          :price="currentGrade?.price"
          :product-uuid="product.id"
          :tracking-info="tracking.product.value"
          zone="details"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { productAPI } from '@backmarket/http-api'
import type { Rating } from '@backmarket/http-api/src/api-specs-reviews/types/rating'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'

import FavoritesToggle from '~/scopes/dashboard/favorites/toggle/FavoritesToggle.vue'
import RatingInfo from '~/scopes/reviews/components/Rating/Rating.vue'

import { useAddToCart } from '../../composables/useAddToCart'
import { useProductTracking } from '../../composables/useProductTracking'
import { useUrlParams } from '../../composables/useUrlParams'
import AdvertisedPayment from '../AdvertisedPayment/AdvertisedPayment.vue'
import Price from '../Price/Price.vue'

import translations from './TitleDesktop.translations'
import EcoBlockAnchor from './components/EcoBlockAnchor/EcoBlockAnchor.vue'

const props = withDefaults(
  defineProps<{
    currentGrade?: productAPI.GetBestOffersResponse[number] | null
    product: productAPI.GetProductResponse
    showEcoBlock?: boolean
    rating?: Rating | null
    tracking: ReturnType<typeof useProductTracking>
    swapStatus?: string
  }>(),
  {
    currentGrade: null,
    showEcoBlock: false,
    rating: null,
    swapStatus: '',
  },
)

const { offerType } = useUrlParams()
const { addToCart } = useAddToCart()
const i18n = useI18n()

function onAddToCart() {
  if (props.currentGrade) {
    addToCart({
      listingId: props.currentGrade.id,
      tracking: {
        ...props.tracking.product.value,
        list: 'product_page',
      },
      swapStatus: props.swapStatus,
    })
  }
}
</script>
